import React from "react";

export function NoTranslation(props) {
    return <span translate="no">{props.children}</span>;
}
